
import React from 'react';
import PipelineProspectDetails from './PipelineProspectDetails';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { motion } from 'framer-motion';

export interface Prospect {
  id: string;
  name: string;
  description?: string;
  location?: string;
  industry?: string;
  employee_count?: number;
  revenue_range?: string;
  website?: string;
  status?: string;
  progress?: number;
}

interface PipelineBoardDetailsProps {
  prospect: Prospect | null;
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (id: string, updatedProspect: Partial<Prospect>) => void;
}

const PipelineBoardDetails = ({
  prospect,
  isOpen,
  onClose,
  onUpdate
}: PipelineBoardDetailsProps) => {
  if (!prospect) return null;

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent className="sm:max-w-md md:max-w-lg p-0 border-none bg-gradient-to-br from-background to-background/95 backdrop-blur-xl shadow-xl">
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          className="h-full"
        >
          <PipelineProspectDetails 
            prospect={prospect} 
            onClose={onClose} 
            onUpdate={onUpdate}
          />
        </motion.div>
      </SheetContent>
    </Sheet>
  );
};

export default PipelineBoardDetails;
